import { render, staticRenderFns } from "./MobileTabNav.vue?vue&type=template&id=1dc6cb0d"
import script from "./MobileTabNav.vue?vue&type=script&lang=js"
export * from "./MobileTabNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dc6cb0d')) {
      api.createRecord('1dc6cb0d', component.options)
    } else {
      api.reload('1dc6cb0d', component.options)
    }
    module.hot.accept("./MobileTabNav.vue?vue&type=template&id=1dc6cb0d", function () {
      api.rerender('1dc6cb0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/MobileTabNav.vue"
export default component.exports